import { render, staticRenderFns } from "./expertDetails.vue?vue&type=template&id=3ef41fc2&scoped=true&"
import script from "./expertDetails.vue?vue&type=script&lang=js&"
export * from "./expertDetails.vue?vue&type=script&lang=js&"
import style0 from "./expertDetails.vue?vue&type=style&index=0&id=3ef41fc2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef41fc2",
  null
  
)

export default component.exports